import { useAsync } from '@nxsys/hooks/useAsync';
import { getBannersApi } from '@nxsys/services/api/banner';
import { GetBannersResponse } from '@nxsys/types/api/banner';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useGetBanners = () => {
  const { value, loading, error, run } = useAsync<GetBannersResponse, void>(
    getBannersApi,
  );

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};
